import {useMemo} from 'react';
import {useGetRefundProcedureTherapiesQuery} from '../queries/useGetRefundProcedureTherapiesQuery';
import {useTherapiesDataStore} from '../store/useTherapiesDataStore';

export const useGetRefundProcedureTherapies = () => {
	const therapies = useTherapiesDataStore(state => state.therapies);
	const therapyTypesAlreadyRecorded = therapies.map(therapy => therapy.therapyType?.code || '');

	const {
		data: therapyTypesData,
		isLoading: isLoadingTherapyTypes,
		isError: isErrorTherapyTypes,
		refetch: refetchTherapyTypes,
	} = useGetRefundProcedureTherapiesQuery({
		therapiesAlreadyRecorded: therapyTypesAlreadyRecorded,
	});

	const isTherapyTypesDataEmpty = useMemo(() => {
		const therapyTypesDataLength = therapyTypesData ? therapyTypesData.length : 0;
		return therapyTypesDataLength === 0;
	}, [therapyTypesData]);

	return {
		therapyTypesData,
		isLoadingTherapyTypes,
		isErrorTherapyTypes,
		isTherapyTypesDataEmpty,
		refetchTherapyTypes,
	};
};
